import { humanizeDigital, humanizeDigitalBinary, humanizeNumber, skipHumanize } from './humanize.js';

export const getFormatter = (options) => {
  try {
    if (options.style === 'currency') {
      return currencyFormatter(options);
    }

    if (options.style === 'digital') {
      return digitalFormatter(options);
    }

    if (options.style === 'digital-binary') {
      return digitalBinaryFormatter(options);
    }

    if (options.style === 'currency-code') {
      return currencyCodeFormatter(options);
    }

    return defaultFormatter(options);
  } catch (error) {
    return fallbackFormatter();
  }
};

const defaultFormatter = (options) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: options.style,
    currency: options.currency,
    minimumFractionDigits: options.precisionLimits.min,
    maximumFractionDigits: options.precisionLimits.max
  });

  return {
    format: (value) => formatter.format(value),
    humanize: humanizeNumber
  };
};

const currencyFormatter = (options) => {
  const currency = options.currency || 'EUR';

  try {
    return defaultFormatter({ ...options, currency });
  } catch (error) {
    return fallbackCurrencyFormatter(options);
  }
};

const fallbackCurrencyFormatter = (options) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: options.precisionLimits.min,
    maximumFractionDigits: options.precisionLimits.max
  });

  return {
    format: value => options.currency + formatter.format(value),
    humanize: humanizeNumber
  };
};

const currencyCodeDefaultFormatter = (options) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currencyDisplay: 'code',
    currency: options.currency || 'EUR',
    minimumFractionDigits: options.precisionLimits.min,
    maximumFractionDigits: options.precisionLimits.max
  });

  return {
    format: value => formatter.format(value),
    humanize: humanizeNumber
  };
};

const currencyCodeFormatter = (options) => {
  try {
    return currencyCodeDefaultFormatter(options);
  } catch (error) {
    return fallbackCurrencyFormatter(options);
  }
};

const fallbackFormatter = () => {
  return {
    format: value => value,
    humanize: skipHumanize
  };
};

const digitalFormatter = (options) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: options.precisionLimits.min,
    maximumFractionDigits: options.precisionLimits.max
  });

  return {
    format: value => formatter.format(value),
    humanize: humanizeDigital
  };
};

const digitalBinaryFormatter = (options) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: options.precisionLimits.min,
    maximumFractionDigits: options.precisionLimits.max
  });

  return {
    format: value => formatter.format(value),
    humanize: humanizeDigitalBinary
  };
};
